import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDraft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 11,
	height: 13,
	viewBox: "0 0 11 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.70513 12.8334C1.36838 12.8334 1.08333 12.7167 0.85 12.4834C0.616667 12.25 0.5 11.965 0.5 11.6282V1.37188C0.5 1.03513 0.616667 0.750081 0.85 0.516748C1.08333 0.283415 1.36838 0.166748 1.70513 0.166748H6.50128C6.66196 0.166748 6.81644 0.197949 6.96473 0.260349C7.11302 0.322737 7.24187 0.408632 7.35128 0.518032L10.1487 3.31543C10.2581 3.42484 10.344 3.55369 10.4064 3.70198C10.4688 3.85027 10.5 4.00475 10.5 4.16543V11.6282C10.5 11.965 10.3833 12.25 10.15 12.4834C9.91663 12.7167 9.63159 12.8334 9.29483 12.8334H1.70513ZM6.5 3.56415V1.16673H1.70513C1.65384 1.16673 1.60683 1.1881 1.56408 1.23083C1.52135 1.27358 1.49998 1.32059 1.49998 1.37188V11.6282C1.49998 11.6795 1.52135 11.7266 1.56408 11.7693C1.60683 11.812 1.65384 11.8334 1.70513 11.8334H9.29483C9.34612 11.8334 9.39314 11.812 9.43588 11.7693C9.47862 11.7266 9.49998 11.6795 9.49998 11.6282V4.16672H7.10257C6.93078 4.16672 6.78741 4.10923 6.67245 3.99426C6.55748 3.87931 6.5 3.73594 6.5 3.56415Z",
		fill: "#023E52"
	})
});
export default SvgDraft;
